import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface SelectableCardProps {
  selected: boolean;
  onSelect: () => void;
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
}

export function SelectableCard({
  selected,
  onSelect,
  icon,
  title,
  description,
  className,
}: SelectableCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-pressed={selected}
      className={cn(
        'pressable flex w-full items-center gap-3 rounded-2xl border-2 bg-card px-4 py-3.5 text-start transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas md:focus-visible:ring-offset-card',
        'pointer-coarse:min-h-[44px]',
        selected ? 'border-brand' : 'border-line-2',
        className,
      )}
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[9px] bg-brand-soft text-brand-ink">
        {icon}
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-body-xl font-semibold text-t1">{title}</div>
        <div className="mt-1 text-body leading-[1.45] text-t3">{description}</div>
      </div>
    </button>
  );
}
